// IntegrationDeleteConfirms.jsx

import React from 'react';

// Components
import Confirm from 'components/confirm/Confirm';

/**
 * IntegrationDeleteConfirms
 *
 * Renders delete confirmation dialogs for outbound rules and incoming webhooks.
 *
 * @param {string} deleteConfirmMessage - Outbound delete confirmation message text.
 * @param {boolean} deleteConfirmOpen - Whether the outbound delete confirm is open.
 * @param {function} onDeleteConfirmOpen - Setter for outbound delete confirm open state.
 * @param {function} onDeleteRule - Confirm handler to delete selected outbound rule.
 * @param {string} incomingDeleteConfirmMessage - Incoming delete confirmation message text.
 * @param {boolean} incomingDeleteConfirmOpen - Whether the incoming delete confirm is open.
 * @param {function} onIncomingDeleteConfirmOpen - Setter for incoming delete confirm open state.
 * @param {function} onDeleteIncomingHook - Confirm handler to delete selected incoming webhook.
 *
 * @returns {ReactNode} The rendered confirmation dialogs.
 */
const IntegrationDeleteConfirms = ({
    deleteConfirmMessage,
    deleteConfirmOpen,
    onDeleteConfirmOpen,
    onDeleteRule,
    incomingDeleteConfirmMessage,
    incomingDeleteConfirmOpen,
    onIncomingDeleteConfirmOpen,
    onDeleteIncomingHook,
}) => {

    // ----- RENDER ----- //

    return (
        <>
            {/* OUTBOUND DELETE CONFIRM */}
            <Confirm
                title="Delete Outbound Rule"
                message={deleteConfirmMessage}
                isOpen={deleteConfirmOpen}
                setOpen={onDeleteConfirmOpen}
                onConfirm={onDeleteRule}
            />

            {/* INCOMING DELETE CONFIRM */}
            <Confirm
                title="Delete Incoming Webhook"
                message={incomingDeleteConfirmMessage}
                isOpen={incomingDeleteConfirmOpen}
                setOpen={onIncomingDeleteConfirmOpen}
                onConfirm={onDeleteIncomingHook}
            />
        </>
    );
};

// Dev Tools
IntegrationDeleteConfirms.displayName = 'IntegrationDeleteConfirms';

export default IntegrationDeleteConfirms;
